import React from 'react';
import { Button, Modal, Typography, Box } from '@mui/material';
import { RedTheme } from 'common/global';
import { useScreen } from 'common/hooks/useScreen';

export const DownloadStartPopup = ({ open, onClose }) => {
  let redtheme = RedTheme;
  const screen = useScreen();
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: redtheme.palette.box.white,
          padding: screen.isMobile ? '12px' : '24px',
          gap: '36px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: screen.isMobile ? '95vw' : '368px',
          borderRadius: '16px',
        }}
      >
        <Box sx={{ width: screen.isMobile ? '320px' : '380px', marginBottom: '20px', gap:'10px' }}>
          <Typography
            sx={{
              fontSize: '32px',
              lineHeight: '32px',
              fontWeight: 700,
              fontFamily: '"JohnsonDisplay-Bold"',
              color: redtheme.palette.text.primary,
              width: '100%',
              display: 'inline',
            }}
          >
            {'Your download request has been submitted.'}
          </Typography>
          <Typography sx={{
              fontSize: '16px',
              lineHeight: '16px',
              fontWeight: 500,
              fontFamily: '"JohnsonText-Regular"',
              color: "#564C47",
              width: '100%',
              display: 'inline-block',
            }}
          >
            {'You will be notified once it is completed.'}
          </Typography>
        </Box>
        <Button
          onClick={onClose}
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            width: '100%',
            // width: screen.isMobile ? '161px' : '182px',
            height: screen.isMobile ? '30px' : '40px',
            borderRadius: '8px',
            fontFamily: '"JohnsonText-Medium"',
            textTransform: 'none',
            color: redtheme.palette.button.white,
            bgcolor: redtheme.palette.primary.main,
            '&:hover': {
              color: redtheme.palette.button.white,
              bgcolor: redtheme.palette.primary.main,
              fontFamily: '"JohnsonText-Medium"',
            },
          }}
          variant='primary'
        >
          {'OK'}
        </Button>
      </Box>
    </Modal>
  );
};
